import { render, staticRenderFns } from "./expand-collapse.vue?vue&type=template&id=0d787696"
import script from "./expand-collapse.ts?vue&type=script&lang=ts&external"
export * from "./expand-collapse.ts?vue&type=script&lang=ts&external"
import style0 from "./expand-collapse.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports